export default function(fields){

    /*
        TODO: need to check if _mkto_trk exists already, otherwise don't load script (maybe)
     */

    //TODO Brian
    // id should be injected via config file for build, seems to different from MKTO environment to environment
    // e.g., MKTO Preprod is '289-HIQ-803'

    //Legacy MKTO
    // let id = '748-MBK-457'

    //Legacy PREPROD MKTO
    //let id = '289-HIQ-803'

    //Production 1MKTO
    let id = '989-BHO-046'

    let config = {
        cookieAnon: false
    }
    let mktoCookie = "_mkto_trk"

    /**
     * Gets a specific cookie val
     * @param cname
     * @returns {string}
     * @private
     */
    function _getCookie(cname) {
        let name = cname + "="
        let decodedCookie = decodeURIComponent(document.cookie)
        let ca = decodedCookie.split(';')
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i]
            while (c.charAt(0) === ' ') {
                c = c.substring(1)
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length)
            }
        }
        return ""
    }

    /**
     *
     * @private
     */
    function _addMunchkinScript(){
        let munchkinJS = document.createElement('script')
        munchkinJS.setAttribute('src', 'https://munchkin.marketo.net/munchkin.js')
        document.body.appendChild(munchkinJS)

        _checkScriptLoad()
    }


    /**
     *
     * @private
     */
    function _initMunchkinTracking(){
        let newScript = document.createElement('script')
        let munchkinTracker = document.createTextNode('mktoMunchkin("'+id+'", '+JSON.stringify(config)+');')
        newScript.appendChild(munchkinTracker)
        document.body.appendChild(newScript)

        fields[mktoCookie] = _getCookie(mktoCookie)
    }

    /**
     *
     * @private
     */
    function _checkScriptLoad(){
        let timeout = 100
        setTimeout(function () {
            timeout--
            if (typeof mktoMunchkin !== 'undefined') {
                _initMunchkinTracking()
            }
            else if (timeout > 0) {
                _checkScriptLoad()
            }
            else {
                // failed to load
            }
        }, 100)
    }

    /**
     *
     * @private
     */
    function _init(){
        fields.munchkinId = id
        _addMunchkinScript()

    }

    _init()

    return {
        setMarketoCookie: function(){
            if(typeof Munchkin !== 'undefined'){
                Munchkin.createTrackingCookie(true)
                fields[mktoCookie] = _getCookie(mktoCookie)
            }
        }
    }
}